export const translations = {
  en: {
    "nav.executive": "Executive Dashboard",
    "nav.public": "Public Dashboard",
    "nav.watchlist": "Stuck Watchlist",
    "nav.meetingPacks": "Meeting Packs",
    "nav.intelligence": "Intelligence Hub",
    "nav.assets": "Asset Registry",
    "nav.approvals": "Approvals",
    "nav.officers": "Officers",
    "nav.recognition": "Recognition",
    "nav.reports": "Reports",
    "nav.evidence": "Evidence",
    "nav.pillars": "Pillars",
    "nav.themes": "Themes",
    "nav.initiatives": "Initiatives",
    "nav.milestones": "Milestones",
    "nav.kpis": "KPIs",
    "nav.departments": "Departments",
    "nav.districts": "Districts",
    "nav.budget": "Budget",
    "nav.risks": "Risks",
    "nav.reviews": "Reviews",
    "nav.copilot": "AI Copilot",
    "nav.settings": "Settings",
    "status.live": "Live",
    "status.offline": "Offline",
    "rag.green": "On Track",
    "rag.amber": "Minor Delay",
    "rag.red": "Major Delay",
    "rag.blue": "Closed",
    "public.title": "Public Transparency Dashboard",
    "page.executive.title": "Executive Command Center",
    "page.watchlist.title": "Stuck & At-Risk Watchlist",
    "page.watchlist.eyebrow": "Governance",
    "page.intelligence.title": "Intelligence Hub",
    "page.intelligence.subtitle": "Delay-risk forecasting, RCA, anomalies, budget forecast, cascade & scenario planning",
    "page.intelligence.eyebrow": "Analytics",
    "page.meetingPacks.title": "Meeting Pack Generator",
    "page.meetingPacks.subtitle": "Auto-assembled review packs for PMO, VMU, CS and CM meetings",
    "page.meetingPacks.eyebrow": "Reviews",
    "page.approvals.title": "Approval Workflow Engine",
    "page.approvals.subtitle": "DPR, financial sanction, evidence, milestone closure and budget workflows",
    "page.approvals.eyebrow": "Governance",
    "page.officers.title": "Officer Accountability & Transfer Tracker",
    "page.officers.subtitle": "Ownership metrics and handover workflow",
    "page.officers.eyebrow": "People",
    "officer.dashboard": "Officer Dashboard",
    "officer.dashboardHint": "Click any row to open accountability drill-down for that officer.",
    "officer.col.officer": "Officer",
    "officer.col.milestones": "Milestones",
    "officer.col.overdue": "Overdue",
    "officer.col.risks": "Risks",
    "officer.col.evidence": "Evidence pending",
    "officer.col.avgDelay": "Avg delay",
    "officer.loading": "Loading officer…",
    "officer.profile": "Officer profile",
    "officer.role": "Role",
    "officer.handover": "Handover status",
    "officer.deptHead": "Department head",
    "officer.quickLinks": "Quick drill-down",
    "officer.link.milestones": "Department milestones",
    "officer.link.initiatives": "Department initiatives",
    "officer.link.risks": "All risks",
    "officer.link.evidence": "Evidence queue",
    "officer.link.departments": "Departments",
    "officer.milestonesSection": "Owned milestones",
    "officer.risksSection": "Open risks",
    "officer.evidenceSection": "Pending evidence",
    "officer.actionsSection": "Overdue review actions",
    "officer.initiativesSection": "Lead initiatives",
    "officer.departmentScope": "Filtered to this officer's department",
    "officer.stat.milestones": "Milestones",
    "officer.stat.overdue": "Overdue actions",
    "officer.stat.risks": "Open risks",
    "officer.stat.evidence": "Evidence pending",
    "officer.stat.avgDelay": "Avg delay",
    "officer.stat.themes": "Themes owned",
    "officer.riskType": "Type",
    "officer.score": "Score",
    "officer.evidenceType": "Evidence type",
    "officer.verification": "Verification",
    "officer.dueDate": "Due date",
    "officer.empty.milestones": "No milestones for this department.",
    "officer.empty.risks": "No open risks linked to department initiatives.",
    "officer.empty.evidence": "No pending evidence for department milestones.",
    "officer.empty.actions": "No overdue actions for this department.",
    "officer.tab.accountability": "Accountability",
    "officer.tab.transfer": "Transfer Tracker",
    "officer.summary.total": "Officers",
    "officer.summary.activeDepts": "Department secretaries & nodal leads",
    "officer.summary.attention": "Needs attention",
    "officer.summary.attentionSub": "High overdue / risk load",
    "officer.summary.overdue": "Overdue actions",
    "officer.summary.overdueSub": "Across all departments",
    "officer.summary.risks": "Open risks",
    "officer.summary.risksSub": "Linked to dept initiatives",
    "officer.summary.avgDelay": "Avg milestone delay",
    "officer.summary.delaySub": "Mean days past plan",
    "officer.attention.title": "Priority follow-up",
    "officer.searchPlaceholder": "Search officer or department…",
    "officer.sortBy": "Sort by",
    "officer.sort.attention": "Needs attention first",
    "officer.sort.overdue": "Most overdue",
    "officer.sort.delay": "Longest delay",
    "officer.sort.milestones": "Most milestones",
    "officer.sort.name": "Name (A–Z)",
    "officer.view.cards": "Cards",
    "officer.view.table": "Table",
    "officer.col.health": "Health",
    "officer.empty.search": "No officers match your search.",
    "officer.health.onTrack": "On track",
    "officer.health.watch": "Watch",
    "officer.health.attention": "Needs attention",
    "officer.accountabilityScore": "accountability",
    "officer.transfer.title": "Initiate officer handover",
    "officer.transfer.subtitle": "Transfer milestones, risks and evidence responsibilities with a structured checklist.",
    "officer.transfer.outgoing": "Outgoing officer",
    "officer.transfer.successor": "Successor",
    "officer.transfer.select": "Select officer",
    "officer.transfer.cta": "Generate handover checklist",
    "officer.transfer.history": "Handover history",
    "officer.transfer.empty": "No transfers recorded yet.",
    "officer.transfer.markComplete": "Mark complete",
    "officer.transfer.selectBoth": "Select both officers",
    "officer.transfer.initiated": "Handover initiated",
    "officer.transfer.complete": "Handover marked complete",
    "page.recognition.title": "Recognition Engine & Leaderboards",
    "page.recognition.subtitle": "Department performance rankings and appreciation notes",
    "page.recognition.eyebrow": "Performance",
    "page.reports.title": "Generate Executive Reports",
    "page.reports.subtitle": "Pre-built reports for CM, Chief Secretary, VMU and departments",
    "page.reports.eyebrow": "Reports & Exports",
    "page.assets.title": "Asset Registry & Geo-tagging",
    "page.assets.subtitle": "Geo-tagged assets linked to milestones and evidence",
    "page.assets.eyebrow": "Infrastructure",
    "page.evidence.title": "Evidence Repository",
    "page.evidence.subtitle": "Upload, verify and track evidence sufficiency by milestone",
    "page.evidence.eyebrow": "Compliance",
    "page.milestones.title": "Milestone Tracker",
    "page.milestones.subtitle": "Monitor completion, delays, evidence and budget utilization",
    "page.milestones.eyebrow": "Delivery",
    "page.kpis.title": "KPI Monitoring",
    "page.kpis.subtitle": "Track KPI health, anomalies and department accountability",
    "page.kpis.eyebrow": "Performance",
    "page.budget.title": "Budget & Financial Tracking",
    "page.budget.subtitle": "Allocated vs utilized with burn-rate forecast and warnings",
    "page.budget.eyebrow": "Finance",
    "page.districts.title": "District Progress & GIS",
    "page.districts.subtitle": "36 districts with benchmarking and regional roll-up",
    "page.districts.eyebrow": "Regions",
    "page.departments.title": "Department Performance",
    "page.departments.subtitle": "Track initiatives, milestones, completion and delays for every department",
    "page.departments.eyebrow": "Accountability",
    "page.risks.title": "Risk Register & Escalation",
    "page.risks.subtitle": "Identify, score and escalate risks with RCA intelligence links",
    "page.risks.eyebrow": "Risk Management",
    "page.reviews.title": "Review Meetings & Action Items",
    "page.reviews.subtitle": "PMO, VMU, CS and CM review cycles with tracked actions",
    "page.reviews.eyebrow": "Governance",
    "page.copilot.title": "AI Copilot",
    "page.copilot.subtitle": "Ask questions about progress, risks, agriculture and recovery actions",
    "page.copilot.eyebrow": "Assistant",
    "page.pillars.title": "Vision 2047 Pillars",
    "page.pillars.subtitle": "Four strategic pillars driving statewide transformation",
    "page.pillars.eyebrow": "Strategy",
    "page.themes.title": "Theme Portfolio",
    "page.themes.subtitle": "16 themes aligned to pillar outcomes",
    "page.themes.eyebrow": "Strategy",
    "page.initiatives.title": "Initiative Portfolio",
    "page.initiatives.subtitle": "Major initiatives and their milestone pipelines",
    "page.initiatives.eyebrow": "Delivery",
    "page.settings.title": "Platform Settings",
    "page.settings.subtitle": "Role, period and notification preferences",
    "page.settings.eyebrow": "Administration",
    "form.save": "Save",
    "form.cancel": "Cancel",
    "form.create": "Create",
    "form.post": "Post",
    "form.reply": "Reply",
    "comment.add": "Add comment",
    "comment.replyTo": "Reply to comment",
    "comment.noComments": "No comments yet.",
    "audit.title": "Audit Trail",
    "audit.empty": "No audit entries yet.",
    "discussion.title": "Discussion",
    "a11y.highContrast": "High contrast",
    "a11y.skipToMain": "Skip to main content",
    "a11y.chartSummary": "Chart showing progress data",
    "a11y.mapDistricts": "Interactive map of Maharashtra districts showing progress by RAG colour",
    "a11y.dialog.milestone": "Form to create or update a milestone record",
    "a11y.dialog.evidence": "Form to upload evidence files linked to a milestone",
    "a11y.dialog.risk": "Form to register a new risk in the risk register",
    "a11y.dialog.review": "Form to schedule a new review meeting",
    "a11y.dialog.actionItem": "Form to create a tracked action item from a review",
    "a11y.dialog.asset": "Form to register or edit a geo-tagged asset",
    "a11y.dialog.approval": "Form to start a new approval workflow",
    "a11y.dialog.initiative": "Form to create or edit an initiative",
    "a11y.dialog.agriTask": "Form to update agriculture sub-task status and dates",
    "chart.ragDonut": "Donut chart of milestone RAG distribution: on track, minor delay, major delay and closed",
    "chart.pillarCompletion": "Bar chart showing completion percentage for each vision pillar",
    "chart.visionTimeline": "Line chart comparing vision target versus actual progress over milestone years",
    "chart.fundingMix": "Pie chart of funding sources: state budget, private, multilateral, CSR and asset monetization",
    "chart.themeBudget": "Bar chart comparing allocated versus utilized budget by theme",
    "chart.kpiTarget": "Horizontal bar chart comparing current KPI values against 2029 targets",
    "chart.themeCompletion": "Bar chart of completion percentage for each theme coloured by RAG status",
    "chart.deptRank": "Bar chart ranking departments by milestone completion performance",
    "chart.agriRag": "Pie chart of agriculture sub-task RAG distribution",
    "chart.agriDeptWorkload": "Bar chart of agriculture sub-task workload by department",
    "chart.delayRisk": "Delay-risk forecast score, category, confidence and recommended actions for selected milestone",
    "chart.rcaAnalysis": "Root cause analysis ranked by confidence with corrective actions and escalation owners",
    "chart.kpiAnomalies": "List of KPIs flagged with statistical anomalies and severity",
    "chart.cascadeSim": "Cascading delay simulation showing impacted milestones and simulated RAG changes",
    "chart.scenarioPlan": "Scenario planner output showing milestones at risk and budget gap under selected scenario",
    "intel.tab.forecast": "Delay Risk",
    "intel.tab.rca": "Auto-RCA",
    "intel.tab.kpi": "KPI Anomalies",
    "intel.tab.budget": "Budget Forecast",
    "intel.tab.cascade": "Cascade Impact",
    "intel.tab.scenario": "Scenario Planner",
    "intel.selectMilestone": "Milestone for analysis",
    "intel.delayDays": "Delay days",
    "intel.simulateRipple": "Simulate ripple",
    "intel.runScenario": "Run scenario",
    "intel.clearRiskView": "Clear risk view",
    "intel.riskViewBanner": "Viewing RCA for risk-linked analysis",
    "intel.score": "Score",
    "intel.category": "Category",
    "intel.confidence": "Confidence",
    "intel.reasons": "Reasons",
    "intel.recommendedActions": "Recommended actions",
    "intel.selectMilestonePrompt": "Select a milestone",
    "intel.noAnomalies": "No anomalies flagged",
    "intel.sourceImpact": "Source",
    "intel.impactedCount": "dependent items affected",
    "intel.turningAmber": "Turning amber",
    "intel.turningRed": "Turning red",
    "intel.budgetGap": "Budget gap (₹ Cr)",
    "intel.mitigation": "Mitigation",
    "intel.tabDesc.forecast": "Predict delay likelihood before milestones slip to red.",
    "intel.tabDesc.rca": "Auto-ranked root causes with owners and escalation paths.",
    "intel.tabDesc.kpi": "Spot KPIs diverging from baseline and 2029 trajectory.",
    "intel.tabDesc.budget": "Burn rate, projected utilization and early warnings.",
    "intel.tabDesc.cascade": "Model ripple impact if a milestone slips by N days.",
    "intel.tabDesc.scenario": "Stress-test shocks: budget cuts, monsoon, vendor delays.",
    "intel.summary.atRisk": "At-risk milestones",
    "intel.summary.atRiskSub": "Amber or red RAG",
    "intel.summary.red": "Major delay (red)",
    "intel.summary.redSub": "Needs immediate review",
    "intel.summary.anomalies": "KPI anomalies",
    "intel.summary.anomaliesSub": "Click to open tab",
    "intel.summary.budget": "Budget alerts",
    "intel.summary.budgetSub": "Forecasts with warnings",
    "intel.searchMilestone": "Filter by code or name…",
    "intel.focusMilestone": "Analysis focus",
    "intel.quickPick": "Quick pick (hot list)",
    "intel.viewWatchlist": "Full watchlist",
    "intel.delayRiskTitle": "Delay-risk score",
    "intel.owner": "Owner",
    "intel.action": "Action",
    "intel.rcaEmpty": "Select a milestone or open from Risks for RCA.",
    "intel.anomalyBadge": "Anomaly",
    "intel.noAnomaliesSub": "All tracked KPIs are within expected bands.",
    "intel.viewKpi": "View KPI registry",
    "intel.budgetOk": "On track",
    "intel.wasRag": "Current RAG",
    "intel.simRag": "After delay",
    "intel.reviewAction": "Review action",
    "intel.cascadeHint": "Choose a milestone and delay days, then run simulation.",
    "intel.scenarioIntro": "What-if stress test across the program",
    "intel.scenarioHint": "Pick a scenario and run to see milestone and budget impacts.",
    "intel.scenario.budget10": "Budget cut 10%",
    "intel.scenario.budget15": "Budget cut 15%",
    "intel.scenario.monsoon": "Monsoon delay 30 days",
    "intel.scenario.vendor": "Vendor delay 60 days",
    "intel.scenario.approval": "Approval delay 45 days",
    "intel.scenario.district": "High-risk district disruption",
    "intel.copilotHint": "Ask the AI Copilot about watchlist items, delay-risk and RCA — it uses the same intelligence engine.",
    "intel.openCopilot": "Open AI Copilot",
    "district.search": "Search district…",
    "district.mapTab": "GIS Map",
    "district.tableTab": "Table",
    "district.legend": "Legend",
    "district.markerSize": "Marker size = progress score",
    "district.clickMarker": "Click a district marker to view detailed metrics.",
    "district.benchmarkTitle": "District Benchmarking & Peer Comparison",
    "district.stateAvg": "State Average Score",
    "district.topPerforming": "Top Performing",
    "district.needsIntervention": "Needs Intervention",
    "district.stat.overall": "Overall Progress",
    "district.stat.infrastructure": "Infrastructure",
    "district.stat.employment": "Employment",
    "district.stat.investment": "Investment",
    "district.stat.welfare": "Welfare Coverage",
    "district.stat.localRisks": "Local Risks",
    "district.stat.evidence": "Evidence Uploaded",
    "district.division": "Division",
    "filter.allThemes": "All Themes",
    "filter.allPillars": "All Pillars",
    "stat.totalRequired": "Total Required",
    "stat.allocated": "Allocated",
    "stat.utilized": "Utilized",
    "stat.privateInvestment": "Private Investment",
    "stat.totalKpis": "Total KPIs",
    "stat.onTrack": "On Track",
    "stat.minorGap": "Minor Gap",
    "stat.offTrack": "Off Track",
    "table.code": "Code",
    "table.name": "Name",
    "table.theme": "Theme",
    "table.unit": "Unit",
    "table.baseline": "Baseline",
    "table.current": "Current",
    "table.target2029": "2029",
    "table.target2035": "2035",
    "table.target2047": "2047",
    "table.health": "Health",
    "table.anomaly": "Anomaly",
    "table.utilPct": "Util %",
    "table.monthlyBurn": "Monthly Burn",
    "table.projectedYe": "Projected YE",
    "table.projUtilPct": "Proj. Util %",
    "table.warnings": "Warnings",
    "table.required": "Required",
    "table.fundingGap": "Funding Gap",
    "table.private": "Private",
    "table.ppp": "PPP",
    "table.closure": "Closure",
    "table.district": "District",
    "table.region": "Region",
    "table.progress": "Progress",
    "table.infra": "Infra",
    "table.employment": "Employment",
    "table.investment": "Investment",
    "table.welfare": "Welfare",
    "table.risks": "Risks",
    "table.rag": "RAG",
    "table.score": "Score",
    "table.vsAvg": "vs Avg",
    "table.peerGroup": "Peer Group",
    "table.burnMo": "Burn/mo",
    "table.caption.budgetForecast": "Budget burn-rate forecast with utilization and warning flags",
    "table.caption.budgetRegister": "Budget register listing allocation, utilization and funding gaps",
    "table.caption.kpiRegister": "KPI register with targets and health status",
    "table.caption.districtBenchmark": "District benchmarking scores compared to state average",
    "table.caption.districtList": "District progress metrics across regions",
    "table.caption.milestoneRegister": "Milestone tracker with status, RAG, delay risk and evidence",
    "table.caption.evidenceRegister": "Evidence register with verification status and linked milestones",
    "table.caption.riskRegister": "Risk register with scores, escalation level and status",
    "table.caption.actionItems": "Review meeting action items with owners and due dates",
    "table.caption.departmentDashboard": "Department performance with completion and delay counts",
    "table.caption.assetRegister": "Geo-tagged asset registry with district and coordinates",
    "table.caption.officers": "Officer accountability metrics by department",
    "table.caption.watchlist": "Milestones and tasks stuck for 30 or more days",
    "table.caption.initiatives": "Initiative portfolio with theme, budget and RAG status",
    "table.caption.agriSubtasks": "Agriculture sub-task tracker with status and variance",
    "table.caption.agriMilestones": "Agriculture mission milestones register",
    "table.caption.agriCriticalPath": "Critical path dependency links with cascading delays",
    "table.caption.agriDependencyLinks": "All agriculture sub-task dependency links",
    "table.caption.agriImportPreview": "Excel import preview — first parsed rows with validation",
    "table.caption.agriBaselines": "Agriculture data baseline versions and active snapshot",
    "table.caption.agriImportHistory": "History of agriculture Excel import batches",
    "table.caption.cascadeImpact": "Cascading delay simulation — impacted milestones and simulated RAG",
    "table.caption.publicDistricts": "Public district progress summary with RAG status",
    "table.caption.settingsPillars": "Reference data — vision pillars",
    "table.caption.settingsThemes": "Reference data — strategic themes by pillar",
    "table.caption.settingsDepartments": "Reference data — lead departments",
    "table.caption.settingsDistricts": "Reference data — district progress scores",
    "table.caption.settingsUsers": "Platform users and role assignments",
    "page.agri.overview.eyebrow": "Agriculture Mission Monitoring",
    "page.agri.overview.title": "Value Chain Initiative · 10–15 High-Value Crops",
    "page.agri.overview.subtitle": "Mission baseline, hierarchy and RAG summary",
    "page.agri.overview.emptyTitle": "Agriculture Value Chain Initiative",
    "page.agri.overview.emptyEyebrow": "Agriculture Mission",
    "page.agri.import.eyebrow": "Agriculture · Excel Import",
    "page.agri.import.title": "Import & Validate Implementation Tracker",
    "page.agri.import.subtitle": "Upload the Agriculture Excel · Preview rows · Validate · Freeze as a baseline version",
    "page.agri.milestones.eyebrow": "Agriculture · Milestone Tracker",
    "page.agri.milestones.title": "10 Milestones · Value Chain Initiative 1.1",
    "page.agri.milestones.subtitle": "Drill-down from each milestone to its tasks and sub-tasks",
    "page.agri.tasks.eyebrow": "Agriculture · Task & Sub-task Tracker",
    "page.agri.tasks.title": "203 Sub-tasks · 53 Tasks",
    "page.agri.tasks.subtitle": "Update status, dates and evidence inline. Filters, search and export available",
    "page.agri.departments.eyebrow": "Agriculture · Department Dashboard",
    "page.agri.departments.title": "9 Departments · Workload & Accountability",
    "page.agri.dependencies.eyebrow": "Agriculture · Dependencies",
    "page.agri.dependencies.title": "Dependency Chain & Critical Path",
    "page.agri.dependencies.subtitle": "Visualize predecessor → successor links. Dependents of delayed predecessors are flagged At-Risk",
    "report.executiveSummary.title": "Vision 2047 Executive Summary",
    "report.executiveSummary.desc": "High-level summary of all 4 pillars and 16 themes with progress, RAG and key risks.",
    "report.pillarProgress.title": "Pillar-wise Progress Report",
    "report.pillarProgress.desc": "Detailed pillar performance with theme drill-down.",
    "report.themeProgress.title": "Theme-wise Progress Report",
    "report.themeProgress.desc": "Per-theme completion, KPIs, budget and evidence.",
    "report.deptPerformance.title": "Department Performance Report",
    "report.deptPerformance.desc": "Department ownership, delivery and accountability.",
    "report.districtProgress.title": "District Progress Report",
    "report.districtProgress.desc": "All 36 districts with regional roll-up.",
    "report.delayedMilestones.title": "Delayed Milestone Report",
    "report.delayedMilestones.desc": "Top delays with planned vs actual variance.",
    "report.riskEscalation.title": "Risk and Escalation Report",
    "report.riskEscalation.desc": "Risk register with escalation chain.",
    "report.evidenceCompliance.title": "Evidence Compliance Report",
    "report.evidenceCompliance.desc": "Evidence verification status and compliance score.",
    "report.budgetUtilization.title": "Budget Utilization Report",
    "report.budgetUtilization.desc": "Allocated vs utilized with funding gaps.",
    "report.cmReview.title": "CM Review Note",
    "report.cmReview.desc": "Auto-generated CM review pack of red and amber items.",
    "report.csReview.title": "Chief Secretary Review Note",
    "report.csReview.desc": "CS-level escalations and steering committee inputs.",
    "report.agriMission.title": "Agriculture Mission Report",
    "report.agriMission.desc": "Consolidated agriculture initiative progress and blockers.",
    "report.agriOverview.title": "Agriculture Executive Progress Summary",
    "report.agriOverview.desc": "Initiative 1.1 progress, milestones, RAG and key blockers.",
    "report.agriMilestones.title": "Agriculture Milestone Progress Report",
    "report.agriMilestones.desc": "10 milestones with completion, FV, RAG and department mix.",
    "report.agriDepartments.title": "Agriculture Department Performance Report",
    "report.agriDepartments.desc": "9 departments with sub-task workload and accountability.",
    "report.agriSubtasks.title": "Agriculture Delayed Sub-task Report",
    "report.agriSubtasks.desc": "Sub-tasks where FV>0 or status in delayed/blocked/at-risk.",
    "report.agriDependencies.title": "Agriculture Dependency Blocker Report",
    "report.agriDependencies.desc": "Critical-path items where predecessor is delayed/blocked.",
    "report.agriCmReview.title": "Agriculture CM Review Note",
    "report.agriCmReview.desc": "CM-level briefing with red/amber milestones and risks.",
    "report.watchlistSection": "Stuck Watchlist (for review packs)",
    "report.fullWatchlist": "Full watchlist",
    "report.noStuckItems": "No stuck items.",
    "report.exportNotConfigured": "Report export not configured",
    "report.downloadFailed": "Download failed",
    "report.downloadSuccess": "downloaded as",
    "report.agriBadge": "Agri",
    "exec.watchlistTitle": "Stuck for 30+ Days Watchlist",
    "exec.viewAll": "View all",
    "exec.noStuckItems": "No stuck items detected.",
    "exec.topDelayed": "Top Delayed Milestones",
    "exec.noDelayed": "No delayed milestones",
    "exec.topRisks": "Top Risk Initiatives",
    "exec.topHighRisk": "Top High-Risk Initiatives",
    "exec.viewRisks": "View risks →",
    "exec.viewAllArrow": "View all →",
    "exec.loading": "Loading executive snapshot…",
    "meeting.packType": "Meeting pack type",
    "meeting.exportTxt": "Export TXT",
    "meeting.exportPdf": "Export PDF",
    "meeting.exporting": "Exporting…",
    "meeting.loading": "Loading meeting pack…",
    "meeting.exportSuccess": "Meeting pack exported as",
    "meeting.exportFailed": "Export failed",
    "meeting.agenda": "Agenda",
    "meeting.lastDecisions": "Last Meeting Decisions",
    "meeting.pendingActions": "Pending Action Items",
    "meeting.nonePending": "None pending",
    "meeting.suggestedDecisions": "Suggested Decisions",
    "meeting.redAmberMs": "Red / Amber Milestones",
    "meeting.topDelayed": "Top Delayed Milestones",
    "meeting.topRisks": "Top Risks",
    "meeting.summaryMetrics": "Summary Metrics",
    "meeting.deptPerformance": "Department-wise Performance",
    "meeting.minutesTemplate": "Minutes Template",
    "meeting.watchlistCount": "Watchlist count",
    "meeting.evidenceCompliance": "Evidence compliance",
    "meeting.avgBudgetUtil": "Avg budget util",
    "meeting.kpiHealth": "KPI health",
    "meeting.pack.weeklyPmo": "Weekly PMO Review",
    "meeting.pack.monthlyDept": "Monthly Department Review",
    "meeting.pack.monthlyVmu": "Monthly VMU Review",
    "meeting.pack.csReview": "Chief Secretary Review",
    "meeting.pack.quarterlyCm": "Quarterly CM Review",
    "evidence.status": "Status",
    "evidence.compliance": "Compliance",
    "evidence.required": "Required",
    "evidence.missing": "Missing",
    "evidence.noneMissing": "None",
    "evidence.loadingSufficiency": "Loading sufficiency check…",
    "evidence.uploadTitle": "Upload Evidence",
    "evidence.uploadSuccess": "Evidence uploaded",
    "evidence.statTotal": "Total",
    "evidence.statAccepted": "Accepted",
    "evidence.statPending": "Pending",
    "evidence.statRejected": "Rejected",
    "evidence.statCompliance": "Compliance",
    "evidence.registerTitle": "Evidence Register",
    "evidence.sufficiencyTitle": "Evidence Sufficiency",
    "evidence.allStatus": "All Status",
    "evidence.statusPending": "Pending",
    "evidence.statusAccepted": "Accepted",
    "evidence.statusRejected": "Rejected",
    "evidence.statusNeedsClarification": "Needs Clarification",
    "evidence.type": "Type",
    "evidence.file": "File",
    "evidence.milestone": "Milestone",
    "evidence.uploadedBy": "Uploaded By",
    "evidence.date": "Date",
    "evidence.pickMilestone": "Pick a milestone",
    "evidence.selectMilestone": "Select milestone",
    "evidence.evidenceType": "Evidence Type",
    "evidence.fileOptional": "File (optional)",
    "evidence.fileHint": "Upload stores file in backend/uploads/ or metadata-only if omitted.",
    "evidence.fileName": "File Name",
    "evidence.remarks": "Remarks",
    "evidence.submitEvidence": "Submit Evidence",
    "evidence.markedStatus": "Marked",
    "evidence.failedPrefix": "Failed:",
    "watchlist.loading": "Loading watchlist…",
    "watchlist.itemsTitle": "Watchlist Items",
    "watchlist.flaggedSuffix": "milestones/tasks flagged · auto-refreshed",
    "watchlist.milestone": "Milestone",
    "watchlist.reasons": "Reasons",
    "watchlist.risk": "Risk",
    "watchlist.analyze": "Analyze",
    "exec.welcome": "Welcome",
    "exec.subtitlePrefix": "Statewide view of Viksit Maharashtra 2047 progress · Reporting period:",
    "exec.agriBadge": "New Module · Drill-Down",
    "exec.agriTitle": "Agriculture Mission Monitoring",
    "exec.agriMeta": "Initiative 1.1 · 10 milestones · 53 tasks · 203 sub-tasks · 9 departments",
    "exec.agriOpen": "Open",
    "exec.visionProgress": "Vision 2047 Progress",
    "exec.budgetUtil": "Budget Utilization",
    "exec.kpiHealth": "KPI Health",
    "exec.openRisks": "Open Risks",
    "exec.visionExplain": "Average completion across all milestones, weighted equally.",
    "exec.budgetExplainPrefix": "of",
    "exec.budgetExplainSuffix": "allocated.",
    "exec.kpiExplainPrefix": "KPIs are off-track and need urgent intervention.",
    "exec.risksExplainPrefix": "risks escalated.",
    "exec.risksExplainSuffix": "overdue actions.",
    "exec.strategicPillars": "Strategic Pillars",
    "exec.viewAllShort": "View all",
    "exec.themesLabel": "Themes",
    "exec.initiativesLabel": "Initiatives",
    "exec.milestonesLabel": "Milestones",
    "exec.delayed": "delayed",
    "exec.atRisk": "at risk",
    "exec.ragStatus": "Milestone Status (RAG)",
    "exec.pillarCompletion": "Pillar-wise Completion",
    "exec.themeMatrix": "16-Theme RAG Matrix",
    "exec.viewAllThemes": "View all themes →",
    "exec.visionTimeline": "Vision Timeline",
    "exec.daysLate": "d late",
    "exec.scoreLabel": "Score:",
    "exec.ragGreen": "Green",
    "exec.ragAmber": "Amber",
    "exec.ragRed": "Red",
    "exec.ragClosed": "Closed",
    "public.loading": "Loading public dashboard…",
    "public.brand": "Viksit Maharashtra 2047",
    "public.officerLogin": "Officer login",
    "public.visionProgress": "Vision 2047 Progress",
    "public.milestonesSuffix": "milestones",
    "public.pillarProgress": "Pillar-wise Progress",
    "public.themeProgress": "Theme-wise Progress",
    "public.evidenceBacked": "Evidence-backed milestones",
    "public.evidenceBackedDesc": "Completed milestones with verified public evidence on record.",
    "public.citizenSnapshot": "Citizen progress snapshot",
    "public.citizenSnapshotBody": "Maharashtra is tracking {pct}% progress toward Viksit Maharashtra 2047, with transparent pillar, theme and district updates published for public accountability.",
    "public.districtProgress": "District Progress (summary)",
    "public.completedProjects": "Major Completed Projects",
    "public.ongoingProjects": "Major Ongoing Projects",
    "public.generated": "Generated",
    "copilot.suggestedPrompts": "Suggested Prompts",
    "copilot.online": "Online",
    "copilot.poweredBy": "Powered by Mistral · Grounded on live platform data",
    "copilot.placeholder": "Ask anything about Viksit Maharashtra 2047…",
    "copilot.welcome": "Hello — I'm your Viksit Maharashtra 2047 AI Copilot, powered by Mistral. I have live access to platform data including watchlist, delay-risk and auto-RCA intelligence. Ask me anything or click a suggested prompt below.",
    "copilot.unavailable": "AI Copilot unavailable right now.",
    "copilot.error": "Copilot error",
    "risk.newRisk": "New Risk",
    "risk.statOpen": "Open",
    "risk.statMitigation": "In Mitigation",
    "risk.statEscalated": "Escalated",
    "risk.statClosed": "Closed",
    "risk.intelligenceTitle": "Intelligence & RCA",
    "risk.intelligenceDesc": "Analyze delay-risk and root causes for milestones linked to escalated risks.",
    "risk.openHub": "Open Intelligence Hub",
    "risk.registerTitle": "Risk Register",
    "risk.escalationMatrix": "Escalation Matrix",
    "risk.newRiskDialog": "New Risk",
    "risk.pickInitiative": "Pick an initiative",
    "risk.added": "Risk added",
    "risk.escalatedTo": "Escalated to",
    "risk.failedPrefix": "Failed:",
    "recognition.loading": "Loading leaderboard…",
    "recognition.topDepts": "Top Performing Departments",
    "recognition.needsIntervention": "Departments Needing Intervention",
    "recognition.notes": "Recognition Notes",
    "recognition.scoreLine": "Score {score}% · On-time {onTime}% · Evidence {evidence}%",
    "recognition.scoreOnly": "Score {score}%",
    "dept.agriShortcut": "Agriculture Mission · Department Workload",
    "dept.agriMeta": "9 departments owning 203 agri sub-tasks",
    "dept.watchlistTitle": "Department Stuck Watchlist",
    "dept.fullWatchlist": "Full watchlist",
    "dept.noStuck": "No stuck items for department review.",
    "dept.rankingTitle": "Department Completion Ranking",
    "dept.dashboardTitle": "Department Dashboard",
    "dept.department": "Department",
    "dept.head": "Head",
    "dept.initiatives": "Initiatives",
    "dept.milestones": "Milestones",
    "dept.delayed": "Delayed",
    "dept.loading": "Loading department…",
    "dept.dashboardHint": "Click a department to open its drill-down dashboard.",
    "dept.searchPlaceholder": "Search departments or heads…",
    "dept.sortBy": "Sort by",
    "dept.sort.progress": "Progress (low first)",
    "dept.sort.delayed": "Most delayed",
    "dept.sort.initiatives": "Most initiatives",
    "dept.sort.milestones": "Most milestones",
    "dept.sort.name": "Name A–Z",
    "dept.view.cards": "Cards",
    "dept.view.table": "Table",
    "dept.viewDetail": "View dashboard",
    "dept.empty.search": "No departments match your search.",
    "dept.summary.total": "Departments",
    "dept.summary.totalSub": "Across Maharashtra Vision",
    "dept.summary.initiativesSub": "Total initiatives",
    "dept.summary.milestonesSub": "Tracked milestones",
    "dept.summary.delayedSub": "Delayed / at risk",
    "dept.summary.avgProgress": "Avg progress",
    "dept.summary.atRisk": "{count} need attention",
    "dept.attention.title": "Departments needing attention",
    "dept.detail.eyebrow": "Department dashboard",
    "dept.detail.kpis": "KPIs",
    "dept.detail.budgetUsed": "Budget used",
    "dept.detail.themes": "Themes owned",
    "dept.detail.accountableOfficer": "Accountable officer",
    "dept.detail.quickLinks": "Quick links",
    "dept.detail.linkInitiatives": "All initiatives",
    "dept.detail.linkMilestones": "All milestones",
    "dept.detail.linkKpis": "Department KPIs",
    "dept.detail.linkRisks": "Open risks",
    "dept.detail.linkBudget": "Budget overview",
    "dept.detail.linkIntel": "Intelligence Hub",
    "dept.detail.themesOwned": "Themes owned by this department",
    "dept.detail.initiativesSection": "Key initiatives",
    "dept.detail.milestonesSection": "Milestones",
    "dept.detail.delayedFirst": "Delayed items shown first",
    "dept.detail.kpiSection": "KPIs",
    "dept.detail.current": "Current",
    "dept.detail.risksSection": "Open risks",
    "dept.detail.actionsSection": "Pending actions",
    "dept.detail.emptyInitiatives": "No initiatives for this department.",
    "dept.detail.emptyMilestones": "No milestones tracked.",
    "dept.detail.emptyKpis": "No KPIs assigned.",
    "dept.detail.emptyRisks": "No open risks.",
    "dept.detail.emptyActions": "No pending actions.",
    "assets.mapTitle": "Asset Map (districts + asset pins)",
    "assets.detailTitle": "Asset Detail",
    "assets.selectAsset": "Select an asset",
    "assets.clickRow": "Click a row below",
    "assets.assetsCount": "Assets",
    "assets.edit": "Edit",
    "assets.delete": "Delete",
    "assets.register": "Register asset",
    "assets.nameRequired": "Asset name is required",
    "assets.updated": "Asset updated",
    "assets.registered": "Asset registered",
    "assets.deleted": "Asset deleted",
    "assets.saveFailed": "Could not save asset",
    "assets.deleteFailed": "Could not delete asset",
    "assets.editDialog": "Edit asset",
    "assets.registerDialog": "Register new asset",
    "assets.selectedCoords": "Selected:",
    "assets.mapLegend": "Asset RAG",
    "assets.mapAttribution": "Leaflet · BharatMap district boundaries (bundled, no login) · Reference: Maharashtra State GIS Portal",
    "assets.gisPortalLink": "Maharashtra State GIS Portal (NIC)",
    "approval.activeWorkflows": "Active workflows",
    "approval.newWorkflow": "New workflow",
    "approval.advanceStage": "Advance stage",
    "approval.history": "History",
    "approval.entityRequired": "Entity name is required",
    "approval.created": "Approval workflow created",
    "approval.deleted": "Workflow deleted",
    "approval.deleteFailed": "Could not delete workflow",
    "approval.createFailed": "Could not create workflow",
    "approval.newDialog": "New approval workflow",
    "approval.workflowType": "Workflow type",
    "approval.entitySubject": "Entity / subject",
    "approval.remarks": "Remarks",
    "approval.create": "Create",
    "chart.publicDistricts": "Public district progress summary table with region, score and RAG status",
    "common.create": "Create",
    "common.cancel": "Cancel",
    "common.actions": "Actions",
    "common.pdf": "PDF",
    "common.csv": "CSV",
    "common.xlsx": "XLSX",
    "lang.toggle": "मराठी",
  },
  mr: {
    "nav.executive": "कार्यकारी डॅशबोर्ड",
    "nav.public": "सार्वजनिक डॅशबोर्ड",
    "nav.watchlist": "अडकलेली यादी",
    "nav.meetingPacks": "बैठक पॅक",
    "nav.intelligence": "बुद्धिमत्ता केंद्र",
    "nav.assets": "मालमत्ता नोंद",
    "nav.approvals": "मंजुरी",
    "nav.officers": "अधिकारी",
    "nav.recognition": "उत्कृष्टता",
    "nav.reports": "अहवाल",
    "nav.evidence": "पुरावा",
    "nav.pillars": "स्तंभ",
    "nav.themes": "प्रसंग/थीम",
    "nav.initiatives": "उपक्रम",
    "nav.milestones": "milestones",
    "nav.kpis": "KPI",
    "nav.departments": "विभाग",
    "nav.districts": "जिल्हे",
    "nav.budget": "अर्थसंकल्प",
    "nav.risks": "धोके",
    "nav.reviews": "पुनरावलोकने",
    "nav.copilot": "AI Copilot",
    "nav.settings": "सेटिंग्ज",
    "status.live": "थेट",
    "status.offline": "ऑफलाइन",
    "rag.green": "मार्गावर",
    "rag.amber": "किरकोळ विलंब",
    "rag.red": "मोठा विलंब",
    "rag.blue": "पूर्ण",
    "public.title": "सार्वजनिक पारदर्शकता डॅशबोर्ड",
    "page.executive.title": "कार्यकारी कमांड केंद्र",
    "page.watchlist.title": "अडकलेले आणि धोक्यातील यादी",
    "page.watchlist.eyebrow": "शासन",
    "page.intelligence.title": "बुद्धिमत्ता केंद्र",
    "page.intelligence.subtitle": "विलंब धोका, RCA, विसंगती, अर्थसंकल्प अंदाज",
    "page.intelligence.eyebrow": "विश्लेषण",
    "page.meetingPacks.title": "बैठक पॅक जनरेटर",
    "page.meetingPacks.subtitle": "PMO, VMU, CS आणि CM बैठकीसाठी पॅक",
    "page.meetingPacks.eyebrow": "पुनरावलोकने",
    "page.approvals.title": "मंजुरी कार्यप्रवाह",
    "page.approvals.subtitle": "DPR, निधी, पुरावा, milestone बंद आणि अर्थसंकल्प",
    "page.approvals.eyebrow": "शासन",
    "page.officers.title": "अधिकारी जबाबदारी आणि स्थानांतरण",
    "page.officers.subtitle": "मालकी मेट्रिक्स आणि handover",
    "page.officers.eyebrow": "लोक",
    "officer.dashboard": "अधिकारी डॅशबोर्ड",
    "officer.dashboardHint": "कोणत्याही ओळीवर क्लिक करून त्या अधिकाऱ्याचा drill-down पहा.",
    "officer.col.officer": "अधिकारी",
    "officer.col.milestones": "माइलस्टोन",
    "officer.col.overdue": "उशीरा",
    "officer.col.risks": "धोके",
    "officer.col.evidence": "पुरावा प्रलंबित",
    "officer.col.avgDelay": "सरासरी विलंब",
    "officer.loading": "अधिकारी लोड होत आहे…",
    "officer.profile": "अधिकारी प्रोफाइल",
    "officer.role": "भूमिका",
    "officer.handover": "Handover स्थिती",
    "officer.deptHead": "विभाग प्रमुख",
    "officer.quickLinks": "द्रुत drill-down",
    "officer.link.milestones": "विभाग माइलस्टोन",
    "officer.link.initiatives": "विभाग उपक्रम",
    "officer.link.risks": "सर्व धोके",
    "officer.link.evidence": "पुरावा रांग",
    "officer.link.departments": "विभाग",
    "officer.milestonesSection": "मालकीचे माइलस्टोन",
    "officer.risksSection": "खुले धोके",
    "officer.evidenceSection": "प्रलंबित पुरावा",
    "officer.actionsSection": "उशीरा review क्रिया",
    "officer.initiativesSection": "प्रमुख उपक्रम",
    "officer.departmentScope": "या अधिकाऱ्याच्या विभागासाठी फिल्टर",
    "officer.stat.milestones": "माइलस्टोन",
    "officer.stat.overdue": "उशीरा क्रिया",
    "officer.stat.risks": "खुले धोके",
    "officer.stat.evidence": "प्रलंबित पुरावा",
    "officer.stat.avgDelay": "सरासरी विलंब",
    "officer.stat.themes": "थीम मालकी",
    "officer.riskType": "प्रकार",
    "officer.score": "गुण",
    "officer.evidenceType": "पुरावा प्रकार",
    "officer.verification": "पडताळणी",
    "officer.dueDate": "देय तारीख",
    "officer.empty.milestones": "या विभागासाठी माइलस्टोन नाहीत.",
    "officer.empty.risks": "विभाग उपक्रमांशी जोडलेले खुले धोके नाहीत.",
    "officer.empty.evidence": "विभाग माइलस्टोनसाठी प्रलंबित पुरावा नाही.",
    "officer.empty.actions": "या विभागासाठी उशीरा क्रिया नाहीत.",
    "officer.tab.accountability": "जबाबदारी",
    "officer.tab.transfer": "स्थानांतरण",
    "officer.summary.total": "अधिकारी",
    "officer.summary.activeDepts": "विभाग प्रमुख आणि nodal",
    "officer.summary.attention": "लक्ष द्या",
    "officer.summary.attentionSub": "उच्च overdue / धोका",
    "officer.summary.overdue": "उशीरा क्रिया",
    "officer.summary.overdueSub": "सर्व विभाग",
    "officer.summary.risks": "खुले धोके",
    "officer.summary.risksSub": "उपक्रमांशी जोडले",
    "officer.summary.avgDelay": "सरासरी विलंब",
    "officer.summary.delaySub": "योजनेपेक्षा दिवस",
    "officer.attention.title": "प्राधान्य follow-up",
    "officer.searchPlaceholder": "अधिकारी किंवा विभाग शोधा…",
    "officer.sortBy": "क्रमवारी",
    "officer.sort.attention": "लक्ष प्रथम",
    "officer.sort.overdue": "सर्वाधिक उशीर",
    "officer.sort.delay": "सर्वाधिक विलंब",
    "officer.sort.milestones": "सर्वाधिक माइलस्टोन",
    "officer.sort.name": "नाव (A–Z)",
    "officer.view.cards": "कार्ड",
    "officer.view.table": "तक्ता",
    "officer.col.health": "आरोग्य",
    "officer.empty.search": "जुळणारे अधिकारी नाहीत.",
    "officer.health.onTrack": "योग्य मार्गावर",
    "officer.health.watch": "निरीक्षण",
    "officer.health.attention": "लक्ष द्या",
    "officer.accountabilityScore": "जबाबदारी",
    "officer.transfer.title": "Handover सुरू करा",
    "officer.transfer.subtitle": "माइलस्टोन, धोके आणि पुरावा जबाबदारी हस्तांतरित करा.",
    "officer.transfer.outgoing": "Outgoing अधिकारी",
    "officer.transfer.successor": "उत्तराधिकारी",
    "officer.transfer.select": "अधिकारी निवडा",
    "officer.transfer.cta": "Handover checklist",
    "officer.transfer.history": "Handover इतिहास",
    "officer.transfer.empty": "अद्याप handover नाही.",
    "officer.transfer.markComplete": "पूर्ण चिन्हांकित",
    "officer.transfer.selectBoth": "दोन्ही अधिकारी निवडा",
    "officer.transfer.initiated": "Handover सुरू",
    "officer.transfer.complete": "Handover पूर्ण",
    "page.recognition.title": "उत्कृष्टता आणि leaderboard",
    "page.recognition.subtitle": "विभाग कामगिरी आणि प्रशंसा",
    "page.recognition.eyebrow": "कामगिरी",
    "page.reports.title": "कार्यकारी अहवाल तयार करा",
    "page.reports.subtitle": "मुख्यमंत्री, मुख्य सचिव, VMU आणि विभागांसाठी",
    "page.reports.eyebrow": "अहवाल आणि निर्यात",
    "page.assets.title": "मालमत्ता नोंद आणि geo-tag",
    "page.assets.subtitle": "milestones आणि पुराव्याशी जोडलेल्या मालमत्ता",
    "page.assets.eyebrow": "पायाभूत सुविधा",
    "page.evidence.title": "पुरावा संग्रह",
    "page.evidence.subtitle": "अपलोड, पडताळणी आणि sufficiency",
    "page.evidence.eyebrow": "अनुपालन",
    "page.milestones.title": "Milestone ट्रॅकर",
    "page.milestones.subtitle": "पूर्णता, विलंब, पुरावा आणि अर्थसंकल्प",
    "page.milestones.eyebrow": "वितरण",
    "page.kpis.title": "KPI देखरेख",
    "page.kpis.subtitle": "KPI आरोग्य, विसंगती आणि जबाबदारी",
    "page.kpis.eyebrow": "कामगिरी",
    "page.budget.title": "अर्थसंकल्प आणि वित्त",
    "page.budget.subtitle": "वाटप, वापर आणि burn-rate अंदाज",
    "page.budget.eyebrow": "वित्त",
    "page.districts.title": "जिल्हा प्रगती आणि GIS",
    "page.districts.subtitle": "३६ जिल्हे benchmarking सह",
    "page.districts.eyebrow": "प्रदेश",
    "page.departments.title": "विभाग कामगिरी",
    "page.departments.subtitle": "उपक्रम, milestones आणि विलंब",
    "page.departments.eyebrow": "जबाबदारी",
    "page.risks.title": "धोका नोंदवही",
    "page.risks.subtitle": "धोके, score, escalation आणि RCA",
    "page.risks.eyebrow": "धोका व्यवस्थापन",
    "page.reviews.title": "पुनरावलोकन बैठका",
    "page.reviews.subtitle": "PMO, VMU, CS, CM चक्र आणि action items",
    "page.reviews.eyebrow": "शासन",
    "page.copilot.title": "AI Copilot",
    "page.copilot.subtitle": "प्रगती, धोके आणि शेती विषयी प्रश्न",
    "page.copilot.eyebrow": "सहाय्यक",
    "page.pillars.title": "दृष्टी २०४७ स्तंभ",
    "page.pillars.subtitle": "चार стратégique स्तंभ",
    "page.pillars.eyebrow": "धोरण",
    "page.themes.title": "थीम पोर्टफोलिओ",
    "page.themes.subtitle": "१६ थीम",
    "page.themes.eyebrow": "धोरण",
    "page.initiatives.title": "उपक्रम पोर्टफोलिओ",
    "page.initiatives.subtitle": "प्रमुख उपक्रम आणि milestones",
    "page.initiatives.eyebrow": "वितरण",
    "page.settings.title": "प्लॅटफॉर्म सेटिंग्ज",
    "page.settings.subtitle": "भूमिका, कालावधी आणि सूचना",
    "page.settings.eyebrow": "प्रशासन",
    "form.save": "जतन करा",
    "form.cancel": "रद्द",
    "form.create": "तयार करा",
    "form.post": "पोस्ट",
    "form.reply": "उत्तर",
    "comment.add": "टिप्पणी जोडा",
    "comment.replyTo": "टिप्पणीला उत्तर",
    "comment.noComments": "अद्याप टिप्पण्या नाहीत.",
    "audit.title": "Audit Trail",
    "audit.empty": "Audit नोंदी नाहीत.",
    "discussion.title": "चर्चा",
    "a11y.highContrast": "उच्च कॉन्ट्रास्ट",
    "a11y.skipToMain": "मुख्य सामग्रीवर जा",
    "a11y.chartSummary": "प्रगती डेटा दर्शविणारा chart",
    "a11y.mapDistricts": "महाराष्ट्र जिल्ह्यांचा RAG रंगानुसार प्रगती दर्शवणारा नकाशा",
    "a11y.dialog.milestone": "Milestone तयार किंवा अद्यतन करण्याचा फॉर्म",
    "a11y.dialog.evidence": "Milestone शी जोडलेला पुरावा अपलोड करण्याचा फॉर्म",
    "a11y.dialog.risk": "धोका नोंदवहीमध्ये नवीन धोका नोंदवण्याचा फॉर्म",
    "a11y.dialog.review": "नवीन पुनरावलोकन बैठक नियोजित करण्याचा फॉर्म",
    "a11y.dialog.actionItem": "पुनरावलोकनातून action item तयार करण्याचा फॉर्म",
    "a11y.dialog.asset": "Geo-tag मालमत्ता नोंदवण्याचा किंवा संपादित करण्याचा फॉर्म",
    "a11y.dialog.approval": "नवीन मंजुरी कार्यप्रवाह सुरू करण्याचा फॉर्म",
    "a11y.dialog.initiative": "उपक्रम तयार किंवा संपादित करण्याचा फॉर्म",
    "a11y.dialog.agriTask": "शेती sub-task स्थिती आणि तारखा अद्यतन करण्याचा फॉर्म",
    "chart.ragDonut": "Milestone RAG वितरण दर्शवणारा donut chart",
    "chart.pillarCompletion": "प्रत्येक स्तंभाची पूर्णता टक्केवारी दर्शवणारा bar chart",
    "chart.visionTimeline": "लक्ष्य आणि प्रत्यक्ष प्रगती तुलना दर्शवणारा line chart",
    "chart.fundingMix": "निधी स्रोत दर्शवणारा pie chart",
    "chart.themeBudget": "थीमनुसार वाटप आणि वापर तुलना bar chart",
    "chart.kpiTarget": "KPI सध्याचे मूल्य आणि 2029 लक्ष्य bar chart",
    "chart.themeCompletion": "थीमनुसार पूर्णता टक्केवारी bar chart",
    "chart.deptRank": "विभाग कामगिरी ranking bar chart",
    "chart.agriRag": "शेती sub-task RAG वितरण pie chart",
    "chart.agriDeptWorkload": "विभागनुसार शेती workload bar chart",
    "chart.delayRisk": "निवडलेल्या milestone साठी विलंब धोका अंदाज, श्रेणी आणि शिफारसी",
    "chart.rcaAnalysis": "मूळ कारण विश्लेषण — confidence, corrective action आणि escalation",
    "chart.kpiAnomalies": "विसंगती असलेले KPI आणि गंभीरता",
    "chart.cascadeSim": "Cascading delay simulation — impacted milestones आणि RAG",
    "chart.scenarioPlan": "Scenario planner — धोक्यातील milestones आणि budget gap",
    "intel.tab.forecast": "विलंब धोका",
    "intel.tab.rca": "Auto-RCA",
    "intel.tab.kpi": "KPI विसंगती",
    "intel.tab.budget": "अर्थसंकल्प अंदाज",
    "intel.tab.cascade": "Cascade Impact",
    "intel.tab.scenario": "Scenario Planner",
    "intel.selectMilestone": "विश्लेषणासाठी milestone",
    "intel.delayDays": "विलंब दिवस",
    "intel.simulateRipple": "Ripple simulate करा",
    "intel.runScenario": "Scenario चालवा",
    "intel.clearRiskView": "Risk view साफ करा",
    "intel.riskViewBanner": "Risk-linked RCA विश्लेषण पाहत आहात",
    "intel.score": "Score",
    "intel.category": "श्रेणी",
    "intel.confidence": "Confidence",
    "intel.reasons": "कारणे",
    "intel.recommendedActions": "शिफारसी",
    "intel.selectMilestonePrompt": "Milestone निवडा",
    "intel.noAnomalies": "विसंगती नाहीत",
    "intel.sourceImpact": "Source",
    "intel.impactedCount": "अवलंबित items प्रभावित",
    "intel.turningAmber": "Amber होणारे",
    "intel.turningRed": "Red होणारे",
    "intel.budgetGap": "Budget gap (₹ Cr)",
    "intel.mitigation": "Mitigation",
    "intel.tabDesc.forecast": "Red होण्यापूर्वी विलंब धोका अंदाज.",
    "intel.tabDesc.rca": "मूळ कारणे, owner आणि escalation.",
    "intel.tabDesc.kpi": "Baseline / 2029 पथापासून विचलन.",
    "intel.tabDesc.budget": "Burn rate आणि चेतावण्या.",
    "intel.tabDesc.cascade": "N दिवस विलंबाचा ripple परिणाम.",
    "intel.tabDesc.scenario": "Budget, पाऊस, vendor delay stress-test.",
    "intel.summary.atRisk": "धोक्यात milestones",
    "intel.summary.atRiskSub": "Amber किंवा red",
    "intel.summary.red": "मोठा विलंब (red)",
    "intel.summary.redSub": "तातडीचे review",
    "intel.summary.anomalies": "KPI विसंगती",
    "intel.summary.anomaliesSub": "Tab उघडण्यासाठी क्लिक",
    "intel.summary.budget": "Budget alerts",
    "intel.summary.budgetSub": "चेतावणीसह अंदाज",
    "intel.searchMilestone": "Code किंवा नावाने शोधा…",
    "intel.focusMilestone": "विश्लेषण focus",
    "intel.quickPick": "झटपट निवड",
    "intel.viewWatchlist": "पूर्ण watchlist",
    "intel.delayRiskTitle": "Delay-risk score",
    "intel.owner": "Owner",
    "intel.action": "क्रिया",
    "intel.rcaEmpty": "Milestone निवडा किंवा Risks वरून RCA.",
    "intel.anomalyBadge": "विसंगती",
    "intel.noAnomaliesSub": "सर्व KPI अपेक्षित श्रेणीत.",
    "intel.viewKpi": "KPI registry",
    "intel.budgetOk": "योग्य",
    "intel.wasRag": "सध्याचे RAG",
    "intel.simRag": "विलंबानंतर",
    "intel.reviewAction": "Review क्रिया",
    "intel.cascadeHint": "Milestone आणि दिवस निवडून simulate करा.",
    "intel.scenarioIntro": "What-if stress test",
    "intel.scenarioHint": "Scenario निवडून program impact पहा.",
    "intel.scenario.budget10": "Budget cut 10%",
    "intel.scenario.budget15": "Budget cut 15%",
    "intel.scenario.monsoon": "Monsoon delay 30 days",
    "intel.scenario.vendor": "Vendor delay 60 days",
    "intel.scenario.approval": "Approval delay 45 days",
    "intel.scenario.district": "District disruption",
    "intel.copilotHint": "AI Copilot ला watchlist, delay-risk आणि RCA विषयी विचारा.",
    "intel.openCopilot": "AI Copilot उघडा",
    "district.search": "जिल्हा शोधा…",
    "district.mapTab": "GIS नकाशा",
    "district.tableTab": "तक्ता",
    "district.legend": "Legend",
    "district.markerSize": "Marker size = progress score",
    "district.clickMarker": "तपशीलासाठी जिल्हा marker वर क्लिक करा.",
    "district.benchmarkTitle": "जिल्हा Benchmarking आणि Peer Comparison",
    "district.stateAvg": "राज्य सरासरी Score",
    "district.topPerforming": "सर्वोत्तम कामगिरी",
    "district.needsIntervention": "हस्तक्षेप आवश्यक",
    "district.stat.overall": "एकूण प्रगती",
    "district.stat.infrastructure": "पायाभूत सुविधा",
    "district.stat.employment": "रोजगार",
    "district.stat.investment": "गुंतवणूक",
    "district.stat.welfare": "कल्याण कव्हरेज",
    "district.stat.localRisks": "स्थानिक धोके",
    "district.stat.evidence": "अपलोड केलेला पुरावा",
    "district.division": "विभाग",
    "filter.allThemes": "सर्व थीम",
    "filter.allPillars": "सर्व स्तंभ",
    "stat.totalRequired": "एकूण आवश्यक",
    "stat.allocated": "वाटप",
    "stat.utilized": "वापर",
    "stat.privateInvestment": "खाजगी गुंतवणूक",
    "stat.totalKpis": "एकूण KPI",
    "stat.onTrack": "मार्गावर",
    "stat.minorGap": "किरकोळ अंतर",
    "stat.offTrack": "मार्गाबाहेर",
    "table.code": "कोड",
    "table.name": "नाव",
    "table.theme": "थीम",
    "table.unit": "एकक",
    "table.baseline": "Baseline",
    "table.current": "सध्याचे",
    "table.target2029": "2029",
    "table.target2035": "2035",
    "table.target2047": "2047",
    "table.health": "आरोग्य",
    "table.anomaly": "विसंगती",
    "table.utilPct": "वापर %",
    "table.monthlyBurn": "मासिक Burn",
    "table.projectedYe": "Proj. YE",
    "table.projUtilPct": "Proj. Util %",
    "table.warnings": "इशारे",
    "table.required": "आवश्यक",
    "table.fundingGap": "निधी अंतर",
    "table.private": "खाजगी",
    "table.ppp": "PPP",
    "table.closure": "Closure",
    "table.district": "जिल्हा",
    "table.region": "प्रदेश",
    "table.progress": "प्रगती",
    "table.infra": "Infra",
    "table.employment": "रोजगार",
    "table.investment": "गुंतवणूक",
    "table.welfare": "कल्याण",
    "table.risks": "धोके",
    "table.rag": "RAG",
    "table.score": "Score",
    "table.vsAvg": "vs Avg",
    "table.peerGroup": "Peer Group",
    "table.burnMo": "Burn/mo",
    "table.caption.budgetForecast": "Budget burn-rate अंदाज आणि इशारे",
    "table.caption.budgetRegister": "Budget नोंद — वाटप, वापर आणि निधी अंतर",
    "table.caption.kpiRegister": "KPI नोंद — लक्ष्ये आणि आरोग्य",
    "table.caption.districtBenchmark": "जिल्हा benchmarking — राज्य सरासरीशी तुलना",
    "table.caption.districtList": "प्रदेशानुसार जिल्हा प्रगती मेट्रिक्स",
    "table.caption.milestoneRegister": "Milestone tracker — स्थिती, RAG, delay risk आणि पुरावा",
    "table.caption.evidenceRegister": "पुरावा नोंद — पडताळणी स्थिती आणि milestones",
    "table.caption.riskRegister": "धोका नोंद — score, escalation आणि स्थिती",
    "table.caption.actionItems": "पुनरावलोकन action items — मालक आणि due dates",
    "table.caption.departmentDashboard": "विभाग कामगिरी — पूर्णता आणि विलंब",
    "table.caption.assetRegister": "Geo-tag मालमत्ता नोंद — जिल्हा आणि coordinates",
    "table.caption.officers": "विभागनुसार अधिकारी जबाबदारी मेट्रिक्स",
    "table.caption.watchlist": "३०+ दिवस अडकलेले milestones आणि tasks",
    "table.caption.initiatives": "Initiative portfolio — थीम, budget आणि RAG",
    "table.caption.agriSubtasks": "शेती sub-task tracker — स्थिती आणि variance",
    "table.caption.agriMilestones": "शेती mission milestones नोंद",
    "table.caption.agriCriticalPath": "Critical path dependencies — cascading delays",
    "table.caption.agriDependencyLinks": "सर्व शेती sub-task dependency दुवे",
    "table.caption.agriImportPreview": "Excel import preview — पहिल्या parsed rows",
    "table.caption.agriBaselines": "शेती data baseline versions आणि active snapshot",
    "table.caption.agriImportHistory": "शेती Excel import batches इतिहास",
    "table.caption.cascadeImpact": "Cascading delay simulation — impacted milestones",
    "table.caption.publicDistricts": "Public district progress summary — RAG status",
    "table.caption.settingsPillars": "Reference data — vision pillars",
    "table.caption.settingsThemes": "Reference data — strategic themes",
    "table.caption.settingsDepartments": "Reference data — lead departments",
    "table.caption.settingsDistricts": "Reference data — district progress",
    "table.caption.settingsUsers": "Platform users आणि role assignments",
    "page.agri.overview.eyebrow": "शेती मिशन देखरेख",
    "page.agri.overview.title": "Value Chain Initiative · 10–15 उच्च-मूल्य पिके",
    "page.agri.overview.subtitle": "Mission baseline, hierarchy आणि RAG सारांश",
    "page.agri.overview.emptyTitle": "शेती Value Chain Initiative",
    "page.agri.overview.emptyEyebrow": "शेती मिशन",
    "page.agri.import.eyebrow": "शेती · Excel Import",
    "page.agri.import.title": "Implementation Tracker Import आणि Validate",
    "page.agri.import.subtitle": "Excel अपलोड · Preview · Validate · Baseline म्हणून freeze",
    "page.agri.milestones.eyebrow": "शेती · Milestone Tracker",
    "page.agri.milestones.title": "10 Milestones · Value Chain Initiative 1.1",
    "page.agri.milestones.subtitle": "प्रत्येक milestone पासून tasks आणि sub-tasks",
    "page.agri.tasks.eyebrow": "शेती · Task & Sub-task Tracker",
    "page.agri.tasks.title": "203 Sub-tasks · 53 Tasks",
    "page.agri.tasks.subtitle": "स्थिती, तारखा आणि पुरावा inline अद्यतन",
    "page.agri.departments.eyebrow": "शेती · विभाग Dashboard",
    "page.agri.departments.title": "9 विभाग · Workload आणि जबाबदारी",
    "page.agri.dependencies.eyebrow": "शेती · Dependencies",
    "page.agri.dependencies.title": "Dependency Chain आणि Critical Path",
    "page.agri.dependencies.subtitle": "Predecessor → successor दुवे; विलंबित predecessors चे dependents At-Risk",
    "report.executiveSummary.title": "दृष्टी २०४७ कार्यकारी सारांश",
    "report.executiveSummary.desc": "४ स्तंभ, १६ थीम, RAG आणि प्रमुख धोके — उच्चस्तरीय सारांश.",
    "report.pillarProgress.title": "स्तंभवार प्रगती अहवाल",
    "report.pillarProgress.desc": "थीम drill-down सह स्तंभ कामगिरी.",
    "report.themeProgress.title": "थीमवार प्रगती अहवाल",
    "report.themeProgress.desc": "थीमनुसार पूर्णता, KPI, अर्थसंकल्प आणि पुरावा.",
    "report.deptPerformance.title": "विभाग कामगिरी अहवाल",
    "report.deptPerformance.desc": "विभाग मालकी, वितरण आणि जबाबदारी.",
    "report.districtProgress.title": "जिल्हा प्रगती अहवाल",
    "report.districtProgress.desc": "सर्व ३६ जिल्हे — प्रादेशिक roll-up.",
    "report.delayedMilestones.title": "विलंबित Milestone अहवाल",
    "report.delayedMilestones.desc": "नियोजित vs प्रत्यक्ष variance सह शीर्ष विलंब.",
    "report.riskEscalation.title": "धोका आणि Escalation अहवाल",
    "report.riskEscalation.desc": "Escalation chain सह धोका नोंदवही.",
    "report.evidenceCompliance.title": "पुरावा अनुपालन अहवाल",
    "report.evidenceCompliance.desc": "पुरावा पडताळणी स्थिती आणि compliance score.",
    "report.budgetUtilization.title": "अर्थसंकल्प वापर अहवाल",
    "report.budgetUtilization.desc": "वाटप vs वापर आणि निधी अंतर.",
    "report.cmReview.title": "मुख्यमंत्री पुनरावलोकन टीप",
    "report.cmReview.desc": "लाल/पिवळ्या items चा CM review pack.",
    "report.csReview.title": "मुख्य सचिव पुनरावलोकन टीप",
    "report.csReview.desc": "CS-level escalations आणि steering committee inputs.",
    "report.agriMission.title": "शेती मिशन अहवाल",
    "report.agriMission.desc": "एकत्रित शेती initiative प्रगती आणि blockers.",
    "report.agriOverview.title": "शेती कार्यकारी प्रगती सारांश",
    "report.agriOverview.desc": "Initiative 1.1 प्रगती, milestones, RAG आणि blockers.",
    "report.agriMilestones.title": "शेती Milestone प्रगती अहवाल",
    "report.agriMilestones.desc": "१० milestones — पूर्णता, FV, RAG आणि विभाग.",
    "report.agriDepartments.title": "शेती विभाग कामगिरी अहवाल",
    "report.agriDepartments.desc": "९ विभाग — sub-task workload आणि जबाबदारी.",
    "report.agriSubtasks.title": "शेती विलंबित Sub-task अहवाल",
    "report.agriSubtasks.desc": "FV>0 किंवा delayed/blocked/at-risk sub-tasks.",
    "report.agriDependencies.title": "शेती Dependency Blocker अहवाल",
    "report.agriDependencies.desc": "Predecessor delayed/blocked असलेले critical-path items.",
    "report.agriCmReview.title": "शेती CM पुनरावलोकन टीप",
    "report.agriCmReview.desc": "लाल/पिवळ्या milestones आणि risks — CM briefing.",
    "report.watchlistSection": "अडकलेली यादी (review packs साठी)",
    "report.fullWatchlist": "पूर्ण watchlist",
    "report.noStuckItems": "अडकलेले items नाहीत.",
    "report.exportNotConfigured": "अहवाल export configure नाही",
    "report.downloadFailed": "डाउनलोड अयशस्वी",
    "report.downloadSuccess": "म्हणून डाउनलोड झाले",
    "report.agriBadge": "शेती",
    "exec.watchlistTitle": "३०+ दिवस अडकलेली यादी",
    "exec.viewAll": "सर्व पहा",
    "exec.noStuckItems": "अडकलेले items नाहीत.",
    "exec.topDelayed": "शीर्ष विलंबित Milestones",
    "exec.noDelayed": "विलंबित milestones नाहीत",
    "exec.topRisks": "शीर्ष धोका Initiatives",
    "exec.topHighRisk": "शीर्ष उच्च-धोका Initiatives",
    "exec.viewRisks": "धोके पहा →",
    "exec.viewAllArrow": "सर्व पहा →",
    "exec.loading": "कार्यकारी snapshot लोड होत आहे…",
    "meeting.packType": "बैठक पॅक प्रकार",
    "meeting.exportTxt": "TXT निर्यात",
    "meeting.exportPdf": "PDF निर्यात",
    "meeting.exporting": "निर्यात होत आहे…",
    "meeting.loading": "बैठक पॅक लोड होत आहे…",
    "meeting.exportSuccess": "बैठक पॅक निर्यात:",
    "meeting.exportFailed": "निर्यात अयशस्वी",
    "meeting.agenda": "कार्यसूची",
    "meeting.lastDecisions": "मागील बैठक निर्णय",
    "meeting.pendingActions": "प्रलंबित Action Items",
    "meeting.nonePending": "प्रलंबित नाहीत",
    "meeting.suggestedDecisions": "सुचवलेले निर्णय",
    "meeting.redAmberMs": "लाल / पिवळे Milestones",
    "meeting.topDelayed": "शीर्ष विलंबित Milestones",
    "meeting.topRisks": "शीर्ष धोके",
    "meeting.summaryMetrics": "सारांश Metrics",
    "meeting.deptPerformance": "विभागवार कामगिरी",
    "meeting.minutesTemplate": "Minutes Template",
    "meeting.watchlistCount": "Watchlist संख्या",
    "meeting.evidenceCompliance": "पुरावा अनुपालन",
    "meeting.avgBudgetUtil": "सरासरी budget util",
    "meeting.kpiHealth": "KPI आरोग्य",
    "meeting.pack.weeklyPmo": "साप्ताहिक PMO पुनरावलोकन",
    "meeting.pack.monthlyDept": "मासिक विभाग पुनरावलोकन",
    "meeting.pack.monthlyVmu": "मासिक VMU पुनरावलोकन",
    "meeting.pack.csReview": "मुख्य सचिव पुनरावलोकन",
    "meeting.pack.quarterlyCm": "त्रैमासिक CM पुनरावलोकन",
    "evidence.status": "स्थिती",
    "evidence.compliance": "अनुपालन",
    "evidence.required": "आवश्यक",
    "evidence.missing": "गहाळ",
    "evidence.noneMissing": "काहीही नाही",
    "evidence.loadingSufficiency": "Sufficiency तपासणी लोड…",
    "evidence.uploadTitle": "पुरावा अपलोड",
    "evidence.uploadSuccess": "पुरावा अपलोड झाला",
    "evidence.statTotal": "एकूण",
    "evidence.statAccepted": "स्वीकृत",
    "evidence.statPending": "प्रलंबित",
    "evidence.statRejected": "नाकारले",
    "evidence.statCompliance": "अनुपालन",
    "evidence.registerTitle": "पुरावा नोंद",
    "evidence.sufficiencyTitle": "पुरावा Sufficiency",
    "evidence.allStatus": "सर्व स्थिती",
    "evidence.statusPending": "प्रलंबित",
    "evidence.statusAccepted": "स्वीकृत",
    "evidence.statusRejected": "नाकारले",
    "evidence.statusNeedsClarification": "स्पष्टीकरण आवश्यक",
    "evidence.type": "प्रकार",
    "evidence.file": "फाईल",
    "evidence.milestone": "Milestone",
    "evidence.uploadedBy": "अपलोड केले",
    "evidence.date": "तारीख",
    "evidence.pickMilestone": "Milestone निवडा",
    "evidence.selectMilestone": "Milestone निवडा",
    "evidence.evidenceType": "पुरावा प्रकार",
    "evidence.fileOptional": "फाईल (ऐच्छिक)",
    "evidence.fileHint": "अपलोड backend/uploads/ मध्ये साठवतो किंवा metadata-only.",
    "evidence.fileName": "फाईल नाव",
    "evidence.remarks": "शेरा",
    "evidence.submitEvidence": "पुरावा सादर करा",
    "evidence.markedStatus": "चिन्हांकित",
    "evidence.failedPrefix": "अयशस्वी:",
    "watchlist.loading": "Watchlist लोड होत आहे…",
    "watchlist.itemsTitle": "Watchlist Items",
    "watchlist.flaggedSuffix": "milestones/tasks flagged · auto-refreshed",
    "watchlist.milestone": "Milestone",
    "watchlist.reasons": "कारणे",
    "watchlist.risk": "धोका",
    "watchlist.analyze": "विश्लेषण",
    "exec.welcome": "स्वागत",
    "exec.subtitlePrefix": "विकसित महाराष्ट्र 2047 राज्यव्यापी दृश्य · अहवाल कालावधी:",
    "exec.agriBadge": "नवीन Module · Drill-Down",
    "exec.agriTitle": "शेती Mission Monitoring",
    "exec.agriMeta": "Initiative 1.1 · 10 milestones · 53 tasks · 203 sub-tasks · 9 departments",
    "exec.agriOpen": "उघडा",
    "exec.visionProgress": "Vision 2047 प्रगती",
    "exec.budgetUtil": "Budget वापर",
    "exec.kpiHealth": "KPI आरोग्य",
    "exec.openRisks": "उघडे धोके",
    "exec.visionExplain": "सर्व milestones वर सरासरी पूर्णता, समान वजन.",
    "exec.budgetExplainPrefix": "पैकी",
    "exec.budgetExplainSuffix": "वाटप.",
    "exec.kpiExplainPrefix": "KPIs off-track — तातडीचे हस्तक्षेप.",
    "exec.risksExplainPrefix": "धोके escalated.",
    "exec.risksExplainSuffix": "overdue actions.",
    "exec.strategicPillars": "रणनीतीक स्तंभ",
    "exec.viewAllShort": "सर्व पहा",
    "exec.themesLabel": "Themes",
    "exec.initiativesLabel": "Initiatives",
    "exec.milestonesLabel": "Milestones",
    "exec.delayed": "delayed",
    "exec.atRisk": "at risk",
    "exec.ragStatus": "Milestone स्थिती (RAG)",
    "exec.pillarCompletion": "स्तंभनुसार पूर्णता",
    "exec.themeMatrix": "16-Theme RAG Matrix",
    "exec.viewAllThemes": "सर्व themes →",
    "exec.visionTimeline": "Vision Timeline",
    "exec.daysLate": "d late",
    "exec.scoreLabel": "Score:",
    "exec.ragGreen": "Green",
    "exec.ragAmber": "Amber",
    "exec.ragRed": "Red",
    "exec.ragClosed": "Closed",
    "public.loading": "सार्वजनिक डॅशबोर्ड लोड होत आहे…",
    "public.brand": "विकसित महाराष्ट्र 2047",
    "public.officerLogin": "अधिकारी login",
    "public.visionProgress": "Vision 2047 प्रगती",
    "public.milestonesSuffix": "milestones",
    "public.pillarProgress": "स्तंभनुसार प्रगती",
    "public.themeProgress": "थीमनुसार प्रगती",
    "public.evidenceBacked": "पुराव्यासह milestones",
    "public.evidenceBackedDesc": "सत्यापित public पुराव्यासह पूर्ण milestones.",
    "public.citizenSnapshot": "नागरिक प्रगती snapshot",
    "public.citizenSnapshotBody": "महाराष्ट्र Viksit Maharashtra 2047 दिशे {pct}% प्रगती tracking करत आहे — स्तंभ, थीम आणि जिल्हा updates public accountability साठी.",
    "public.districtProgress": "जिल्हा प्रगती (summary)",
    "public.completedProjects": "प्रमुख पूर्ण प्रकल्प",
    "public.ongoingProjects": "प्रमुख सुरू प्रकल्प",
    "public.generated": "Generated",
    "copilot.suggestedPrompts": "Suggested Prompts",
    "copilot.online": "Online",
    "copilot.poweredBy": "Mistral · live platform data",
    "copilot.placeholder": "Viksit Maharashtra 2047 बद्दल विचारा…",
    "copilot.welcome": "नमस्कार — मी Viksit Maharashtra 2047 AI Copilot. Watchlist, delay-risk आणि auto-RCA intelligence उपलब्ध. खाली prompt निवडा किंवा विचारा.",
    "copilot.unavailable": "AI Copilot सध्या उपलब्ध नाही.",
    "copilot.error": "Copilot error",
    "risk.newRisk": "नवीन धोका",
    "risk.statOpen": "उघडे",
    "risk.statMitigation": "Mitigation मध्ये",
    "risk.statEscalated": "Escalated",
    "risk.statClosed": "बंद",
    "risk.intelligenceTitle": "Intelligence & RCA",
    "risk.intelligenceDesc": "Escalated risks शी linked milestones साठी delay-risk आणि root cause विश्लेषण.",
    "risk.openHub": "Intelligence Hub उघडा",
    "risk.registerTitle": "धोका नोंद",
    "risk.escalationMatrix": "Escalation Matrix",
    "risk.newRiskDialog": "नवीन धोका",
    "risk.pickInitiative": "Initiative निवडा",
    "risk.added": "धोका जोडला",
    "risk.escalatedTo": "Escalated to",
    "risk.failedPrefix": "अयशस्वी:",
    "recognition.loading": "Leaderboard लोड…",
    "recognition.topDepts": "शीर्ष कामगिरी विभाग",
    "recognition.needsIntervention": "हस्तक्षेप आवश्यक विभाग",
    "recognition.notes": "Recognition Notes",
    "recognition.scoreLine": "Score {score}% · On-time {onTime}% · Evidence {evidence}%",
    "recognition.scoreOnly": "Score {score}%",
    "dept.agriShortcut": "शेती Mission · Department Workload",
    "dept.agriMeta": "9 departments · 203 agri sub-tasks",
    "dept.watchlistTitle": "विभाग अडकलेली Watchlist",
    "dept.fullWatchlist": "पूर्ण watchlist",
    "dept.noStuck": "विभाग review साठी अडकलेले items नाहीत.",
    "dept.rankingTitle": "विभाग पूर्णता Ranking",
    "dept.dashboardTitle": "विभाग Dashboard",
    "dept.department": "विभाग",
    "dept.head": "Head",
    "dept.initiatives": "Initiatives",
    "dept.milestones": "Milestones",
    "dept.delayed": "Delayed",
    "dept.loading": "विभाग लोड होत आहे…",
    "dept.dashboardHint": "Drill-down dashboard साठी विभागावर click करा.",
    "dept.searchPlaceholder": "विभाग किंवा head शोधा…",
    "dept.sortBy": "Sort by",
    "dept.sort.progress": "Progress (कमी प्रथम)",
    "dept.sort.delayed": "सर्वाधिक delayed",
    "dept.sort.initiatives": "सर्वाधिक initiatives",
    "dept.sort.milestones": "सर्वाधिक milestones",
    "dept.sort.name": "Name A–Z",
    "dept.view.cards": "Cards",
    "dept.view.table": "Table",
    "dept.viewDetail": "Dashboard पहा",
    "dept.empty.search": "कोणतेही विभाग सापडले नाहीत.",
    "dept.summary.total": "विभाग",
    "dept.summary.totalSub": "Maharashtra Vision across",
    "dept.summary.initiativesSub": "Total initiatives",
    "dept.summary.milestonesSub": "Tracked milestones",
    "dept.summary.delayedSub": "Delayed / at risk",
    "dept.summary.avgProgress": "Avg progress",
    "dept.summary.atRisk": "{count} need attention",
    "dept.attention.title": "Departments needing attention",
    "dept.detail.eyebrow": "Department dashboard",
    "dept.detail.kpis": "KPIs",
    "dept.detail.budgetUsed": "Budget used",
    "dept.detail.themes": "Themes owned",
    "dept.detail.accountableOfficer": "Accountable officer",
    "dept.detail.quickLinks": "Quick links",
    "dept.detail.linkInitiatives": "All initiatives",
    "dept.detail.linkMilestones": "All milestones",
    "dept.detail.linkKpis": "Department KPIs",
    "dept.detail.linkRisks": "Open risks",
    "dept.detail.linkBudget": "Budget overview",
    "dept.detail.linkIntel": "Intelligence Hub",
    "dept.detail.themesOwned": "Themes owned by this department",
    "dept.detail.initiativesSection": "Key initiatives",
    "dept.detail.milestonesSection": "Milestones",
    "dept.detail.delayedFirst": "Delayed items shown first",
    "dept.detail.kpiSection": "KPIs",
    "dept.detail.current": "Current",
    "dept.detail.risksSection": "Open risks",
    "dept.detail.actionsSection": "Pending actions",
    "dept.detail.emptyInitiatives": "No initiatives for this department.",
    "dept.detail.emptyMilestones": "No milestones tracked.",
    "dept.detail.emptyKpis": "No KPIs assigned.",
    "dept.detail.emptyRisks": "No open risks.",
    "dept.detail.emptyActions": "No pending actions.",
    "assets.mapTitle": "Asset Map (districts + pins)",
    "assets.detailTitle": "Asset Detail",
    "assets.selectAsset": "Asset निवडा",
    "assets.clickRow": "खाली row क्लिक करा",
    "assets.assetsCount": "Assets",
    "assets.edit": "Edit",
    "assets.delete": "Delete",
    "assets.register": "Asset नोंद",
    "assets.nameRequired": "Asset नाव आवश्यक",
    "assets.updated": "Asset updated",
    "assets.registered": "Asset registered",
    "assets.deleted": "Asset deleted",
    "assets.saveFailed": "Save अयशस्वी",
    "assets.deleteFailed": "Delete अयशस्वी",
    "assets.editDialog": "Asset edit",
    "assets.registerDialog": "नवीन asset",
    "assets.selectedCoords": "Selected:",
    "assets.mapLegend": "Asset RAG",
    "assets.mapAttribution": "Leaflet · BharatMap जिल्हा सीमा (स्थानिक, लॉगिन नाही) · संदर्भ: Maharashtra State GIS Portal",
    "assets.gisPortalLink": "Maharashtra State GIS Portal (NIC)",
    "approval.activeWorkflows": "Active workflows",
    "approval.newWorkflow": "New workflow",
    "approval.advanceStage": "Advance stage",
    "approval.history": "History",
    "approval.entityRequired": "Entity नाव आवश्यक",
    "approval.created": "Workflow created",
    "approval.deleted": "Workflow deleted",
    "approval.deleteFailed": "Delete अयशस्वी",
    "approval.createFailed": "Create अयशस्वी",
    "approval.newDialog": "New approval workflow",
    "approval.workflowType": "Workflow type",
    "approval.entitySubject": "Entity / subject",
    "approval.remarks": "Remarks",
    "approval.create": "Create",
    "chart.publicDistricts": "Public district progress summary — region, score आणि RAG",
    "common.create": "Create",
    "common.cancel": "रद्द",
    "common.actions": "कृती",
    "common.pdf": "PDF",
    "common.csv": "CSV",
    "common.xlsx": "XLSX",
    "lang.toggle": "English",
  },
};
